import { Risk, RISK_MATH } from '@trustero/trustero-api-web/lib/risk/risk_pb'
import { useMemo } from 'react'
import { SearchableData } from 'src/Utils/search/search.types'
import { prepareSearchableData } from 'src/Utils/search/search.helpers'
import { useRiskComputedValues, useActualRiskCalculation } from '../risks.hooks'
import { RISK_MATH_LABEL, RISK_STATUS_FILTER } from '../risks.constants'

export const useSearchableRisks = (risks: Risk[]): SearchableData<Risk>[] => {
  const { getCategoryName } = useRiskComputedValues()
  const searchableRisks = useMemo(() => {
    return prepareSearchableData(
      risks,
      (risk: Risk) => risk.getId(),
      (risk: Risk) => {
        const { actualRiskReduction, inherentRisk } = GetRiskCalculations(risk)
        const id = risk.getCustomId()
        const name = risk.getName()
        const categoryName = getCategoryName(risk)
        const controlCount = risk.getControlIds().split(',').length
        const actualRiskReductionLabel =
          RISK_MATH_LABEL[actualRiskReduction] || actualRiskReduction
        const inherentRiskLabel =
          RISK_MATH_LABEL[inherentRisk as RISK_MATH] || inherentRisk
        const targetResidualRiskLabel =
          RISK_MATH_LABEL[risk.getRiskAfterTreatment() as RISK_MATH] ||
          risk.getRiskAfterTreatment()
        const status =
          RISK_STATUS_FILTER.find((s) => s.value === risk.getStatus())?.name ||
          risk.getStatus()

        return [
          id,
          name,
          categoryName,
          controlCount,
          actualRiskReductionLabel,
          inherentRiskLabel,
          targetResidualRiskLabel,
          status,
        ]
      },
    )
  }, [risks, getCategoryName])

  return searchableRisks
}

export const GetRiskCalculations = (
  risk: Risk,
): { actualRiskReduction: RISK_MATH; inherentRisk: RISK_MATH } => {
  const { actualRiskReduction, inherentRisk } = useActualRiskCalculation(risk)
  return {
    actualRiskReduction,
    inherentRisk,
  }
}
